import { useBlocksConfig, useSyncer } from "@pathwright/blocks-engine"
import { MediaManager } from "@pathwright/legacy-media-manager"
import Button from "@pathwright/ui/src/components/button/Button"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import PropTypes from "prop-types"
import { AttachmentsAddWrapper } from "../ui"

export const AddAttachmentButton = ({ onClick, label, disabled }) => {
  const { tc } = useTranslate()

  return (
    <Button
      className=""
      onClick={onClick}
      styleType="empty"
      stretch
      style={{ height: "50px" }}
      color="#666"
      disabled={disabled}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center"
        }}
      >
        <Pathicon icon="plus-circle" style={{ marginRight: "0.5rem" }} />
        {label || tc("Add Attachment")}
      </div>
    </Button>
  )
}

export const AttachmentsAdd = ({ onAddAttachment }) => {
  const { userID, accountID, isSuperuser, contextKey } = useBlocksConfig()
  const { blocksContext } = useSyncer()

  return (
    <AttachmentsAddWrapper>
      <MediaManager
        contextKey={contextKey}
        mediaStoragePath={blocksContext?.mediaStoragePath}
        mediaType="any"
        onChooseMedia={onAddAttachment}
        userID={userID}
        accountID={accountID}
        renderButton={({ onClick }) => (
          <AddAttachmentButton onClick={onClick} />
        )}
        isSuperuser={isSuperuser}
      />
    </AttachmentsAddWrapper>
  )
}

AttachmentsAdd.propTypes = {
  onAddAttachment: PropTypes.func.isRequired
}

export default AttachmentsAdd
